import React from 'react';
import PropTypes from 'prop-types';

const LpHeader = ({ order, questionsCount }) => (
  <>
    <div className="lp-survey-step-padding">
      <strong className="text-center c-kale-500">
        Step {order} of {questionsCount}
      </strong>
    </div>
  </>
);

LpHeader.propTypes = {
  order: PropTypes.number.isRequired,
  questionsCount: PropTypes.number.isRequired,
};

export default LpHeader;
